import {makeStyles} from "@material-ui/core/styles";
import {topHeight} from "../../../../stores/NavigateStore";

export const  useStyles = makeStyles((theme) => ({
    root:{
        width: '100%',
        height: 'calc(100vh - 102px)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    emptyBox:{
        width: '100%',
        height: `calc(100vh - ${topHeight}px - 36px - 20px - 24px - 24px)`,
        display:'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& p':{
            fontSize: '1.375rem',
            color: '#87888d',
            fontWeight:400,
            textAlign: 'center',
            lineHeight: '30.36px'
        }
    },
    loginBox: {

    },
    boxInner: {
        border: '1px solid #C0C2C3',
        width: 620,
        height: 430,
        background: '#fff',
        '& > .MuiTypography-root': {
            textAlign: 'center',
            fontSize: '1.688rem',
            margin: '50px 0px 30px',

        }
    },
    passwordBox: {
        textAlign: 'right',
        marginTop: 10,
        '& .MuiTypography-root': {
            fontSize: '0.875rem',
            color: '#0D0D0D',
            textDecoration: 'underline',
        },
        '& .MuiButtonBase-root': {
            '&:hover': {
                background: 'transparent',
            }
        },
    },
    textLoginBox: {
        marginLeft: 10,
        '& .MuiFormControl-root': {
            width: 365,
            height: 40,
            boxSizing: 'border-box',
            marginRight: 10,
            marginBottom: 10,
        },
        '& .MuiOutlinedInput-root': {
            height: 40
        },
        '& .MuiButtonBase-root': {
            width: 70,
            height: 40,
            background: 'rgba(16, 18, 28, 0.3)',
            '& .MuiTypography-root': {
                fontSize: '1.125rem',
                color: 'rgba(255, 255, 255, 0.7)',
                fontWeight: 'bold'
            }
        },
        '& .MuiOutlinedInput-input': {
            padding: '9px 10px',
        }
    },
    LoginButton: {
        background: '#c2c2c2',
        width: 365,
        height: 56,
        marginLeft: 70,
        marginTop: 10,
        '&.MuiButtonBase-root': {
            '&:hover': {
                background: '#c2c2c2',
            }
        },
        '& .MuiTypography-root': {
            fontSize: '1.25rem',
            color: '#fff',
            fontWeight: 'bold'
        }
    },
    LoginButtonActive: {
        background: '#7445FF',
        '&.MuiButtonBase-root': {
            '&:hover': {
                background: '#7445FF',
            }
        },
    },
    LoginText: {
        '& .MuiTypography-root': {
            fontSize: '1rem',
            textAlign: 'left',
            width: 70,
            color: '#0D0D0D',
            marginBottom: 10,
        }
    },
    reused: {
        marginRight: 150,
    },
    noticeText: {
        marginLeft: 65,
        '& .MuiTypography-root': {
            fontSize: '0.875rem',
            textAlign: 'left',
            color: '#FF0000',
            marginLeft: 5,
        },
    },
    sendEmail: {
        marginTop: 100,
        background: '#808287',
        width: 490,
        height: 70,
        borderRadius: 5,
        '& .MuiTypography-root': {
            fontSize: '1.25rem',
            color: '#fff',
            textAlign: 'center',
            lineHeight: '55px',
            marginLeft: 10,
        }
    },


    resetText: {
        '&.MuiTypography-root': {
            marginTop: 150,
        }
    },
    resetLogin: {
        width: 365,
        height: 56,
        marginTop: 10,
        background: '#7445FF',
        '&.MuiButtonBase-root': {
            '&:hover': {
                background: '#7445FF',
            }
        },
        '& .MuiTypography-root': {
            fontSize: '1.25rem',
            color: '#fff',
            fontWeight: 'bold'
        }
    },
    resetBoxInner: {
        border: '1px solid #C0C2C3',
        width: 620,
        height: 511,
        background: '#fff',
    },
    titleText: {
        '&.MuiTypography-root': {
            textAlign: 'center',
            fontSize: '1.688rem',
            margin: '50px 0px 0px',
        }
    },
    subText: {
        '&.MuiTypography-root': {
            fontSize: '1rem',
            margin: '30px 0 30px',
            textAlign: 'center',
        }
    },
    loginResetText: {
        marginTop: 15,
        '& .MuiTypography-root': {
            fontSize: '1rem',
            textAlign: 'left',
            width: 90,
            color: '#0D0D0D',
            marginBottom: 10,
        }
    },
    checkList: {
        width: 300,
        textAlign: 'left',
        marginLeft: 30,
        marginBottom: 10,
        '& .MuiTypography-root': {
            fontSize: '0.875rem',
            textAlign: 'left',
            color: '#6C6969',
            marginLeft: 10,
        },
        '& svg': {
            marginLeft: 5,
        }
    },


    dialogWrap: {
        '& .MuiDialog-paperWidthSm': {
            maxWidth: 600,
            width: '100%',
            height: 230,
            padding: 30,
        }
    },
    titleDialog: {
        '& .MuiTypography-root': {
            fontSize: '1.563rem',
            fontWeight: 'bold',
        }
    },
    subDialog: {
        '& .MuiTypography-root': {
            fontSize: '1.25rem',
            color: '#616161',
            marginBottom: 10,
        }
    },
    inputBox: {
        marginTop: 20,
        '& .MuiFormControl-root': {
            width: 400,
            height: 40,
            boxSizing: 'border-box',
            background: '#fff',
        },
        '& .MuiOutlinedInput-root': {
            height: 40
        },
        '& .MuiOutlinedInput-input': {
            padding: '9px 10px',
        }
    },
    inputButton: {
        '&.MuiButtonBase-root': {
            width: 120,
            background: '#d4d4d4',
            height: 40,
            '&:hover': {
                background: '#d4d4d4',
            }
        },
        '& .MuiTypography-root': {
            fontSize: '1.125rem',
            color: '#fff',
            fontWeight: 'bold',
        }
    },
    inputButtonActive: {
        '&.MuiButtonBase-root': {
            background: '#7445FF',
            '&:hover': {
                background: '#7445FF',
            }
        },
    },
    iconButton:{
        padding: '9px 14px',
        '&:hover':{
            background: 'transparent'
        }
    },

    dialogBox: {
        "& .MuiDialog-paper": {
            borderRadius: 30,
            padding: '15px 40px'
        },
        "& .MuiDialogContent-root": {
            padding: 0
        },
        "& .MuiDialogTitle-root": {
            padding: '0 90px'
        }
    },
    dialogTitleBox: {
        display: 'flex',
        flexDirection: 'column',
        alignContent: 'center',
        alignItems: 'center',
        textAlign:'center'
    },
    dialogTitleText: {
        fontFamily: 'NanumSquareRoundOTF',
        fontSize: 27,
        fontWeight: 300,
        color: '#0d0d0d',
        textAlign: 'center',
    },
    dialogBtnStyle:{
        width:'49%',
        padding:'14px 0',
        background: '#33acff',
        fontFamily:'NanumSquareRoundOTF',
        fontSize:14,
        fontWeight:600,
        color:'#fff',
        "&:hover":{
            background:'#0097FF'
        }
    },
    dialogBtnStyle1:{
        width:'49%',
        padding:'14px 0',
        background:'#a3a8af',
        fontFamily:'NanumSquareRoundOTF',
        fontSize:14,
        fontWeight:600,
        color:'#fff',
        marginRight:'2%',
        "&:hover":{
            background:'#a3a8af'
        }
    },

}));

